// Dimensões do modal de saldo e dos modais de detalhe abertos a partir dele
// (faturas antecipadas e detalhe da contestação). Os detalhes ficam ~12%
// menores nos dois eixos para dar sensação de hierarquia — o de saldo é a tela
// cheia de tabela, o detalhe é um recorte dentro dela.
export const BALANCE_MODAL_MAX_WIDTH = '80vw'
export const BALANCE_MODAL_HEIGHT = '80vh'
export const DETAIL_MODAL_MAX_WIDTH = '70vw'
export const DETAIL_MODAL_HEIGHT = '70vh'
